<app-layout-page>
  <app-layout-header>
  </app-layout-header>

  <app-layout-content>
    <div class="large-icon-with-inset" aria-hidden="true">
      <img src="/assets/image/graphic/phone-camera.svg" class="large-icon">
      <mat-icon class="inset-icon color-error">error</mat-icon>
    </div>

    <h2 trans="face_check.media_error.title"></h2>

    <p trans="face_check.media_error.p1"></p>


  </app-layout-content>

  <app-layout-buttons>
    <button class="btn btn-primary pull-center next" (click)="refresh()" trans="face_check.media_error.button"></button>
    @if (showBrowserProblemLink) {
      <app-browser-problem-link></app-browser-problem-link>
    }
  </app-layout-buttons>

</app-layout-page>
